var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard", attrs: { id: "container" } },
    [
      _c("MapComponent", {
        attrs: { openDialog: _vm.openDialog, event: _vm.currentEvent }
      }),
      _c(
        "div",
        { attrs: { id: "dashboardContainer" } },
        _vm._l(_vm.listDashboard, function(item) {
          return _c(
            "v-card",
            {
              key: item.key,
              class: item.tag,
              style: _vm.porcentVCard,
              attrs: { id: "cardDashboard" },
              on: {
                click: function($event) {
                  return _vm.filtroWidget(item.tag)
                }
              }
            },
            [
              _c("div", { staticStyle: { "text-align": "center" } }, [
                _c("div", { staticClass: "titleCard" }, [
                  _vm._v(_vm._s(item.title))
                ]),
                _c("div", { staticClass: "contentCard" }, [
                  _vm._v(_vm._s(item.value))
                ])
              ])
            ]
          )
        }),
        1
      ),
      _vm._m(0),
      _c("div", { attrs: { id: "filtersContainer" } }, [
        _c("div", { attrs: { id: "filtersContainerLeft" } }, [
          _c(
            "div",
            { attrs: { id: "filtersContainerLeft-left" } },
            [
              _c("v-text-field", {
                staticStyle: { "margin-left": "1%" },
                attrs: { label: "Buscar..." },
                on: { input: _vm.searchData },
                model: {
                  value: _vm.searchInput,
                  callback: function($$v) {
                    _vm.searchInput = $$v
                  },
                  expression: "searchInput"
                }
              })
            ],
            1
          )
        ]),
        _c(
          "div",
          { attrs: { id: "filtersContainerRight" } },
          [
            _c(
              "v-btn",
              {
                attrs: {
                  id: "btnExportCsv",
                  flat: "",
                  small: "",
                  color: "primary"
                },
                on: { click: _vm.onBtnExport }
              },
              [
                _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                  _vm._v("cloud_download")
                ]),
                _vm._v("  \n        "),
                _c("span", { staticClass: "importExportBtnTexto" }, [
                  _vm._v("Exportar"),
                  _c("br"),
                  _vm._v("CSV")
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "div",
        { attrs: { id: "gridContainer" } },
        [
          _c(
            "v-card",
            { staticStyle: { width: "100%" } },
            [
              _c("GridComponent", {
                ref: "gridComponent",
                staticClass: "ag-theme-material",
                attrs: { id: "gridComponent", gridOptions: _vm.gridOptions }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "descriptionActiveContainer" } }, [
      _c("ul", [
        _c(
          "h3",
          { staticStyle: { "font-size": "1.6vmin", "font-weight": "400" } },
          [
            _vm._v(
              "\n        *Se considera activo cuando haya reportado su posición o una alerta.\n      "
            )
          ]
        )
      ]),
      _c("ul", [
        _c(
          "h3",
          { staticStyle: { "font-size": "1.6vmin", "font-weight": "400" } },
          [
            _vm._v(
              "\n        *Se considera en línea cuando la cámara está conectada al servidor.\n      "
            )
          ]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }